export class PhotoConstant {
  static readonly MAX_FILE_SIZE = 50000000;
}
